module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./SpecialClassifyView.js"));
	}, "SpecialClassifyView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=SpecialClassifyView!./src/pages/Shop/Home/SpecialClassify/SpecialClassifyView.js
// module id = 904
// module chunks = 438